import {Avatar} from "@mui/material";
import styles from "../tables/table.module.css";
import React, {useEffect} from "react";

// this component is used to display comments both paper and task
const TaskComment = ({comment, stringToColor}) => {
    // in the paper variant, the author is the sender
    if (comment.sender === undefined) {
        comment.sender = comment.author
    }
    useEffect(() => {
        console.log(comment);
    }, []);

    return (
        <div className="d-flex align-items-center gap-2 mb-4 ">
            <div>
                <Avatar
                    className="mt-0"
                    alt={`${comment.sender.first_name} ${comment.sender.last_name}`}
                    src={" "}
                    sx={{
                        fontSize: 14,
                        width: 30,
                        height: 30,
                        bgcolor: stringToColor(comment.sender.first_name),
                    }}
                />
            </div>
            <div>
                <span className={`fw-semibold text-color-tertiary ${styles.commentTitle}`}>{`${comment.sender.first_name} ${comment.sender.last_name}`}</span>
                <p className={`${styles.commentBody}`}>{comment.content}</p>
            </div>
        </div>
    )
}

export default TaskComment
